/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// REACT ///
import { useEffect } from "react";
import { useState } from "react";
/// ACTIONS ///
import { updateLocalShopCounter } from "api/actions/shop_quote";
import { replaceRestorePoint } from "api/actions/history";
import { createRestorePoint } from "api/actions/history";
import { restore } from "api/actions/history";
/// TYPES ///
import { IHistoryActionType } from "api/types/history";
import { IShopCounter } from "api/types/shop_quote/counter";
import { IShopCorner } from "api/types/shop_quote/corner";
import { IShopSlab } from "api/types/shop_quote/slab";
/// COMPONENTS ///
import UpdateWidth from "components/quote/drawer/update_width";
/// FUNCTIONS ///
import { createShopCorners } from "functions/sketch/create/shop_corner";
import { getFirstShopSlabInAreas } from "functions/sketch/get/shop_slab";
import { handleUpdateShopCounter } from "handler/shop_counter/update";
import { updateShopWidth } from "functions/sketch/update/shop_width";

interface Props {
  open: boolean,
  setOpen: (open: boolean) => void,
  original_value: number | null,
  point_uuid: string,
  selected_counter: IShopCounter | null
}

export default function UpdateShopWidth({ open, setOpen, original_value, point_uuid, selected_counter }: Props) {
  const dispatch = useAppDispatch();
  const { areas } = useAppSelector(state => state.shop_quote);
  const { cut_shapes } = useAppSelector(state => state.shop_quote);
  const [error, setError] = useState<string>("");
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    if (open && original_value) {
      setWidth(original_value);
      dispatch(replaceRestorePoint(
        {
          undo_action: IHistoryActionType.UPDATE_SHOP_COUNTER,
          desc: "Cancel Update Width",
          undo_data: { ...selected_counter }
        }
      ));
    }
  }, [open, dispatch]);

  const update = (width: number) => {
    setWidth(Number(width));
    if (isNaN(Number(width)) === false && Number(width) >= 1) {
      setError("");
      let new_width: number = Number(width);
      if (selected_counter) {
        const counter: IShopCounter | null = updateShopWidth(selected_counter, point_uuid, new_width);
        if (counter) {
          const new_corners: IShopCorner[] = createShopCorners(counter.points, [...counter.corners], counter.uuid);
          dispatch(updateLocalShopCounter({ ...counter, corners: new_corners }));
        }
      }
    }
  }

  const cancel = () => {
    dispatch(restore());
    setOpen(false);
    setError("");
  }

  const save = () => {
    if (isNaN(Number(width)) || width < 1) {
      setError('Measurement must be larger than 1"');
      return;
    }
    if (selected_counter && width) {
      const new_counter: IShopCounter = updateShopWidth(selected_counter, point_uuid, width);
      const new_corners: IShopCorner[] = createShopCorners(new_counter.points, [...new_counter.corners], new_counter.uuid);
      const counter: IShopCounter = { ...new_counter, corners: new_corners };
      const slab: IShopSlab | null = getFirstShopSlabInAreas(areas, counter.area_uuid);
      handleUpdateShopCounter(
        dispatch,
        { ...selected_counter },
        counter,
        cut_shapes.filter(shape => shape.counter_uuid === counter.uuid),
        slab.uuid,
        "Change Counter Width"
      );
    }
    else {
      setError("An error has occurred, please refresh the page and try again.");
    }
    setOpen(false);
    setError("");
  }

  return (
    <UpdateWidth
      open={open}
      width={width}
      error={error}
      setOpen={setOpen}
      update={update}
      save={save}
      cancel={cancel} />
  );
}
